export const SECONDS_PER_DAY = 86_400;
const SECONDS_PER_WEEK = 604_800;
const SECONDS_PER_MONTH = 2_629_746;
const SECONDS_PER_YEAR = 31_556_952;

const VISIT_FREQUENCY_TIERS = [
  { perSeconds: SECONDS_PER_DAY, unit: 'day' },
  { perSeconds: SECONDS_PER_WEEK, unit: 'week' },
  { perSeconds: SECONDS_PER_MONTH, unit: 'month' },
  { perSeconds: SECONDS_PER_YEAR, unit: 'year' },
] as const;

const roundToTenth = (value: number): number => Math.round(value * 10) / 10;

export function calculateMemberVisitAverage(memberAverageSecondsBetweenVisit: number | undefined): string {
  if (!memberAverageSecondsBetweenVisit) return '0';

  const rates = VISIT_FREQUENCY_TIERS.map((t) => ({
    unit: t.unit,
    timesPerUnit: roundToTenth(t.perSeconds / memberAverageSecondsBetweenVisit),
  }));
  const { unit, timesPerUnit } = rates.find((r) => r.timesPerUnit >= 1) ?? rates[rates.length - 1];
  return `${timesPerUnit} times/${unit}`;
}

export const formatVisitFrequency = (averageDaysBetweenVisits: number): string =>
  averageDaysBetweenVisits > 0 ? calculateMemberVisitAverage(averageDaysBetweenVisits * SECONDS_PER_DAY) : 'N/A';

export class VisitFrequency {
  constructor(public readonly days: number) {}

  toString(): string {
    return formatVisitFrequency(this.days);
  }

  valueOf(): number {
    return this.days > 0 ? 1 / this.days : 0;
  }
}
